import { render } from "../views/layout-carousel.html?vue&type=template&id=48b0be31&ts=true&external"
import script from "../scripts/layout-carousel.ts?vue&type=script&lang=ts&external"
export * from "../scripts/layout-carousel.ts?vue&type=script&lang=ts&external"

import "../css_builds/components/layout-carousel.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/layout-carousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48b0be31"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48b0be31', __exports__)) {
    api.reload('48b0be31', __exports__)
  }
  
  module.hot.accept("../views/layout-carousel.html?vue&type=template&id=48b0be31&ts=true&external", () => {
    api.rerender('48b0be31', render)
  })

}


export default __exports__